/**
 * Day keys are opaque strings in core, which has no clock and no `Date`.
 * The view layer is the only place allowed to turn one back into a timestamp,
 * and only ever to hand it to `Intl` for formatting.
 */
export function dateToMs(date: string): number {
  const [y, m, d] = date.split('-').map(Number);
  return Date.UTC(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}
